import TermsAndConditionsDialog from './TermsAndConditionsDialog';

export default TermsAndConditionsDialog;
